import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { infoButton_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;

export class filterSearch_template extends vnTemplate {

    protected delay = 400;
    protected debounceTimerId: number;
    protected lastRequestedValue = "";
    public tooltip: infoButton_template;

    protected getTemplateHtml(): string {
        return `
            <div class="w-search-feild icon i-search2">
                <input
                    type="input"
                    class="search-feild"
                    data-bind="
                        textInput: filterKeyword,
                        event: { input: onInputFilterAction },
                        attr: { placeholder: placeHolderText }
                    "
                >
                <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                <input data-bind="value: filterKeywordRequestedKeyWord" type="hidden">

                <button
                    data-bind="event: { click: onClearInput }, css: { 'is-showing': filterInputClearButton }"
                    class="close-btn icon i-x-after"
                    id="close-btn"
                    type="button">
                </button>

                <div data-bind="visible: tooltipVisible" class="w-tooltips-adv auto-height">
                    ${this.tooltip.getHtmlBuild()}
                </div>
            </div>
        `;
    }

    protected getTemplateName(): string {
        return "filterSearch-template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["filter-keyword-wrap"];
    }

    protected initPartial(): void {
        this.tooltip = new infoButton_template(
            "toolTipSearch",
            this.getTemplateViewModel(),
            this.caller
        );
        this.tooltip.setTitle("Search Bar:");
    }

    protected buildViewModel(): any {
        let self = this;

        return {
            filterKeyword: ko.observable(""),
            filterKeywordLastKeyPress: ko.observable(""),
            filterKeywordRequestedKeyWord: ko.observable(""),
            filterInputClearButton: ko.observable(0),

            placeHolderText: ko.observable(""),

            onClearInput: function (data, event) {
                self.onClearInput(event);
            },
            onInputFilterAction: function (data, event) {
                self.onInputFilterAction(data, event);
            },

            tooltipVisible: ko.observable(false)
        };
    }

    protected onInputFilterAction(data, event) {
        this.getTemplateViewModel().filterInputClearButton(1);

        clearTimeout(this.debounceTimerId);

        let self = this;
        this.debounceTimerId = window.setTimeout(function () {
            self.cancelFilter();
            self.applyFilter();
        }, this.delay);
    }

    protected onClearInput(event) {
        this.getTemplateViewModel().filterInputClearButton(0);
        this.getTemplateViewModel().filterKeyword("");
        this.applyFilter();
    }

    private applyFilter() {
        this.caller.filterSearchOnChange(this.idElement);
    }

    private cancelFilter() {
        this.caller.filterSearchCancel();
    }

    public setPlaceholder(text: string) {
        this.getTemplateViewModel().placeHolderText(text);
    }

    public setTooltipTitle(tooltipTitle: string) {
        this.tooltip.setTitle(tooltipTitle);
    }

    public setTooltipContent(tooltipContent: string) {
        if (tooltipContent === "") {
            this.getTemplateViewModel().tooltipVisible(false);
        } else {
            this.getTemplateViewModel().tooltipVisible(true);
        }
        this.tooltip.setContent(tooltipContent);
    }

    public setSearchableFields(searchableFields: Array<any>) {
        let msg =
            "<p>This allows you to search partial matches, contained in the following fields:</p>" +
            "<ul><li>" +
            searchableFields.join(",</li><li>") +
            "</li></ul>";
        this.setTooltipContent(msg);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterSearch_template.ts